import { render, staticRenderFns } from "./prepareOfferDialog.vue?vue&type=template&id=2020e74b&scoped=true"
import script from "./prepareOfferDialog.vue?vue&type=script&lang=js"
export * from "./prepareOfferDialog.vue?vue&type=script&lang=js"
import style0 from "./prepareOfferDialog.vue?vue&type=style&index=0&id=2020e74b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020e74b",
  null
  
)

export default component.exports